import { isNH, isWAYZQA } from "@/constants/config"
import { lazy } from "react"
import type { RouteProps } from "react-router-dom"

export interface AuthRouteProps extends RouteProps {
  isAuthenticated?: boolean // 是否登录
}

const DefaultRoutes: AuthRouteProps[] = [
  {
    isAuthenticated: true,
    path: "/",
    element: lazy(() => import("@/pages/Sandtable")),
  },
  // {
  //   isAuthenticated: true,
  //   path: "/users/:brandId",
  //   element: lazy(() => import("@/pages/UsersControl")),
  // },
  // {
  //   isAuthenticated: true,
  //   path: "/join/:brandId/:code",
  //   element: lazy(() => import("@/pages/Passport/PerfectInformation")),
  // },
  // {
  //   isAuthenticated: true,
  //   path: "/login/:brandId/:code", // 兼容前期代码
  //   element: lazy(() => import("@/pages/Passport/PerfectInformation")),
  // },
  {
    path: "/passport/login",
    element:
      isNH && !isWAYZQA
        ? lazy(() => import(`@/pages/Passport/NHLogin`))
        : lazy(() => import(`@/pages/Passport/Login`)),
  },
  {
    path: "/passport/logout",
    element:
      isNH && !isWAYZQA
        ? lazy(() => import(`@/pages/Passport/NHLogout`))
        : lazy(() => import(`@/pages/Passport/Logout`)),
  },
  {
    path: "/passport/auth",
    element: lazy(() => import("@/pages/Passport/Auth")),
  },
  {
    path: "/privacypolicy",
    element: lazy(() => import("@/pages/PrivacyPolicy")),
  },

  {
    path: "/noMatch",
    element: lazy(() => import("@/pages/NoMatch")),
  },
  {
    path: "/operation",
    element: lazy(() => import("@/pages/OperationManual")),
  },
  {
    path: "/intro",
    element: lazy(() => import("@/pages/IntroPage")),
  },
]

// 金融品牌沙盘（不需要地图）
const TabWithoutMapRoutes: AuthRouteProps[] = [
  {
    isAuthenticated: true,
    path: "marketing",
    element: lazy(() => import("@/pages/Marketing")),
  },
  {
    isAuthenticated: true,
    path: "competitor",
    element: lazy(() => import("@/pages/Competitor")),
  },
  {
    isAuthenticated: true,
    path: "guerlain",
    element: lazy(() => import("@/pages/Guerlain")),
  },
]

// 金融品牌沙盘（需要地图）
const TabWithMapRoutes: AuthRouteProps[] = [
  {
    isAuthenticated: true,
    path: "indicator",
    element: lazy(() => import("@/pages/Indicator")),
  },
  {
    isAuthenticated: true,
    path: "analysis",
    element: lazy(() => import("@/pages/Analysis")),
  },
  {
    isAuthenticated: true,
    path: "eco",
    element: lazy(() => import("@/pages/Ecosystem")),
  },
  {
    isAuthenticated: true,
    path: "mall",
    element: lazy(() => import("@/pages/Mall")),
  },
  {
    isAuthenticated: true,
    path: "selection",
    element: lazy(() => import("@/pages/Selection")),
  },
  {
    isAuthenticated: true,
    path: "situation",
    element: lazy(() => import("@/pages/ClientSituation")),
  },
  {
    isAuthenticated: true,
    path: "relatively",
    element: lazy(() => import("@/pages/Relatively")),
  },
  {
    isAuthenticated: true,
    path: "starbucksSelection",
    element: lazy(() => import("@/pages/Selection")),
  },
  {
    isAuthenticated: true,
    path: "insights",
    element: lazy(() => import("@/pages/Insights")),
  },
  {
    isAuthenticated: true,
    path: "region-insight",
    element: lazy(() => import("@/pages/RegionInsight")),
  },
]

// 飞吉特平台
const InsightsRoutes: AuthRouteProps[] = [
  {
    isAuthenticated: true,
    path: "feijite",
    element: lazy(() => import("@/pages/Feijite")),
  },
]

// 园区沙盘
const ParkRoutes: AuthRouteProps[] = [
  {
    isAuthenticated: true,
    path: "area-overview",
    element: lazy(() => import("@/pages/AreaOverview")),
  },
]

const routes = {
  DefaultRoutes,
  TabWithoutMapRoutes,
  TabWithMapRoutes,
  InsightsRoutes,
  ParkRoutes,
}

export default routes
